import { render, staticRenderFns } from "./ReceiveResetPassword.vue?vue&type=template&id=e4f9dd2e&scoped=true&"
import script from "./ReceiveResetPassword.vue?vue&type=script&lang=js&"
export * from "./ReceiveResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f9dd2e",
  null
  
)

export default component.exports